const AGREEMENTS_GET = 'EXPERIENCE_FORM_AGREEMENTS_GET';
const AGREEMENTS_SET = 'EXPERIENCE_FORM_AGREEMENTS_SET';
const AGREEMENT_TOGGLE = 'EXPERIENCE_FORM_AGREEMENTS_TOGGLE';
const AGREEMENTS_FETCH_ERROR = 'EXPERIENCE_FORM_AGREEMENTS_FETCH_ERROR';


const agreementsGet = () => ({
  type: AGREEMENTS_GET
});

const agreementsSet = (agreements) => ({
  type: AGREEMENTS_SET,
  payload: {
    agreements
  }
});

const agreementToggle = (agreement) => ({
  type: AGREEMENT_TOGGLE,
  payload: {
    agreement
  }
});

const agreementsFetchError = () => ({
  type: AGREEMENTS_FETCH_ERROR
});


export {
  agreementsFetchError,
  agreementsGet,
  agreementsSet,
  agreementToggle,
  AGREEMENTS_FETCH_ERROR,
  AGREEMENTS_SET,
  AGREEMENTS_GET,
  AGREEMENT_TOGGLE
};
